import { goToPage } from '@/utils/router'

const createState = () => ({
  // имя роута детальной страницы для перехода по id
  namePageDetailed: ''
})

const createActions = () => ({
  // переход на страницу детальной информации по id
  async goToPageById ({ state }, id) {
    await goToPage(state.namePageDetailed, { id })
  }
})

const vuexRouterBase = {
  createState,
  createActions
}

export {
  vuexRouterBase
}
